// Central API client for GurSetu web. Uses REACT_APP_BACKEND_URL and prefixes /api.
const BASE = process.env.REACT_APP_BACKEND_URL || "";

export class ApiError extends Error {
  constructor(status, message, data) {
    super(message);
    this.status = status;
    this.data = data;
  }
}

function url(path) {
  return `${BASE}${path.startsWith("/api") ? path : `/api${path}`}`;
}

async function parseError(res, path) {
  const text = await res.text();
  let data = null;
  try { data = text ? JSON.parse(text) : null; } catch { data = text; }
  const msg = (data && (data.detail?.message || data.detail || data.message)) || `${path} → ${res.status}`;
  return new ApiError(res.status, typeof msg === "string" ? msg : JSON.stringify(msg), data);
}

export const api = {
  base: BASE,
  url,
  async get(path, opts = {}) {

  const res =
    await fetch(
      url(path),
      {
        headers:
          opts?.token
            ? {
                Authorization:
                  `Bearer ${opts.token}`,
              }
            : {},

        signal:
          opts?.signal,
      }
    );


  if (!res.ok) {

    throw await parseError(
      res,
      `GET ${path}`
    );

  }


  return res.json();

},
  async post(path, body, opts) {
    const res = await fetch(url(path), {
      method: "POST",
      headers: { "Content-Type": "application/json", ...(opts?.token ? { Authorization: `Bearer ${opts.token}` } : {}) },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw await parseError(res, `POST ${path}`);
    return res.json();
  },
  async postForm(path, formData, opts) {
    const res = await fetch(url(path), {
      method: "POST",
      headers: { ...(opts?.token ? { Authorization: `Bearer ${opts.token}` } : {}) },
      body: formData,
    });
    if (!res.ok) throw await parseError(res, `POST ${path}`);
    return res.json();
  },
  async put(path, body, opts) {
    const res = await fetch(url(path), {
      method: "PUT",
      headers: { "Content-Type": "application/json", ...(opts?.token ? { Authorization: `Bearer ${opts.token}` } : {}) },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw await parseError(res, `PUT ${path}`);
    return res.json();
  },
  async del(path, opts) {
    const res = await fetch(url(path), { method: "DELETE", headers: opts?.token ? { Authorization: `Bearer ${opts.token}` } : {} });
    if (!res.ok) throw await parseError(res, `DELETE ${path}`);
    return res.json();
  },
};

export const StorageKeys = {
  Lang: "ck_lang",
  OnboardingComplete: "ck_onboarding_v1",
  UserId: "ck_user_id",
  UserProfile: "ck_user_profile",
  PreferredGurudwara: "ck_pref_gid",
  AdminToken: "ck_admin_token",
  ChallengeStartDate: "gs_challenge_start",
  ChallengeDays: "gs_challenge_days",
  SimranStreak: "ck_simran_streak",
  SimranLastDate: "ck_simran_date",
  SimranTotal: "gs_simran_total",
  FontSize: "ck_font_size",
  Theme: "ck_theme",
  DismissedAnnouncement: "ck_dismissed_ann",
  ChatSession: "ck_chat_session",
  ReflectionSession: "ck_reflection_session",
  SavedHukam: "ck_saved_hukam",
  SavedTeachings: "ck_saved_teachings",
  Journal: "gs_hukam_journal",
  DeviceId: "gs_device_id",
  DailyGoals: "gs_checklist_",
  MorningRitualDate: "gs_morning_ritual_date",
};
